import { AsyncJobType } from '@recruitee/account/data';
import { bulkActionFactory } from '@recruitee/async-job/data';
import { BulkCandidateResponse } from '@recruitee/http/types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

import { Ids } from './bulk-actions-http-client';

const idSelector = ({ uuid }: BulkCandidateResponse) => uuid;
const { actions, namespace, reducer, selectors } =
  createEntityCollectionStore<BulkCandidateResponse>()('candidate-bulk-actions', {
    idSelector,
    // eslint-disable-next-line max-lines-per-function
    customActions: adapter => {
      const getActions = bulkActionFactory(adapter);
      return {
        ...getActions('addTask', AsyncJobType.BulkCandidatesAddTask)<Ids & { task: any }>(),
        ...getActions('delete', AsyncJobType.BulkCandidatesDeleteCandidates)<Ids>(),
        ...getActions('follow', AsyncJobType.BulkCandidatesFollow)<Ids>(),
        ...getActions('unfollow', AsyncJobType.BulkCandidatesUnfollow)<Ids>(),
        ...getActions('requalify', AsyncJobType.BulkCandidatesRequalify)<
          Ids & { offerId: number }
        >(),
        ...getActions('disqualify', AsyncJobType.BulkCandidatesDisqualify)<
          Ids & {
            offerId: number;
            disqualifyReasonId: number;
            runActions?: boolean | null;
          }
        >(),
        ...getActions('assign', AsyncJobType.BulkCandidatesAssign)<Ids & { offersIds: number[] }>(),
        ...getActions('unassign', AsyncJobType.BulkCandidatesUnassign)<
          Ids & { offersIds: number[] }
        >(),
        ...getActions('changeStage', AsyncJobType.BulkCandidatesChangeStage)<
          Ids & {
            offerId: number;
            stageId: number;
            runActions?: boolean | null;
            hiredAt?: string;
            jobStartsAt?: string;
          }
        >(),
        ...getActions('addTags', AsyncJobType.BulkCandidatesAddTags)<Ids & { items: string[] }>(),
        ...getActions('addSources', AsyncJobType.BulkCandidatesAddSources)<
          Ids & { items: string[] }
        >(),
        ...getActions(
          'extendGdprExpirationDate',
          AsyncJobType.BulkCandidatesSetGdprCustomExpiresAt,
        )<Ids & { gdprCustomExpiresAt: string }>(),
        ...getActions('retrieve', AsyncJobType.BulkCandidatesRetrieveCandidates)<Ids>(),
      };
    },
  });

const CandidateBulkActions = <
  Pick<
    typeof actions,
    | 'addTask'
    | 'addTaskSuccess'
    | 'addTaskFailed'
    | 'delete'
    | 'deleteSuccess'
    | 'deleteFailed'
    | 'follow'
    | 'followSuccess'
    | 'followFailed'
    | 'unfollow'
    | 'unfollowSuccess'
    | 'unfollowFailed'
    | 'requalify'
    | 'requalifySuccess'
    | 'requalifyFailed'
    | 'disqualify'
    | 'disqualifySuccess'
    | 'disqualifyFailed'
    | 'assign'
    | 'assignSuccess'
    | 'assignFailed'
    | 'unassign'
    | 'unassignSuccess'
    | 'unassignFailed'
    | 'changeStage'
    | 'changeStageSuccess'
    | 'changeStageFailed'
    | 'addTags'
    | 'addTagsSuccess'
    | 'addTagsFailed'
    | 'addSources'
    | 'addSourcesSuccess'
    | 'addSourcesFailed'
    | 'extendGdprExpirationDate'
    | 'extendGdprExpirationDateSuccess'
    | 'extendGdprExpirationDateFailed'
    | 'retrieve'
    | 'retrieveSuccess'
    | 'retrieveFailed'
  >
>actions;

export {
  CandidateBulkActions,
  selectors as CandidateBulkSelectors,
  reducer as CandidateBulkReducer,
  namespace as CandidateBulkNamespace,
};
